import { useCallback, useState } from "react";
import { readCharacterId } from "./buildDiscoverChatbotCardViewModel";
export default function useDiscoverChatbotProfileOverlayState() {
    const [stateSelected, setStateSelected] = useState(null);
    const open = useCallback((rowCharacter) => {
        setStateSelected({ characterId: readCharacterId(rowCharacter), preview: rowCharacter });
    }, []);
    const close = useCallback(() => {
        setStateSelected(null);
    }, []);
    return { selected: stateSelected, open, close };
}
